import { render, staticRenderFns } from "./ArticuloEquivalente.vue?vue&type=template&id=9bb3a082&"
import script from "./ArticuloEquivalente.vue?vue&type=script&lang=js&"
export * from "./ArticuloEquivalente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports